import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T, CARD_SHADOW } from "../../constants";

/* ---------- Compact stat tile (signature card, tight padding) ---------- */

const useStyles = makeStyles({
  tile: {
    background: T.elevated,
    border: `1px solid ${T.borderSoft}`,
    borderRadius: 14,
    boxShadow: CARD_SHADOW,
    padding: 16,
  },
  value: { fontSize: 24, fontWeight: 600, lineHeight: 1, color: T.fg },
  label: { marginTop: 6, fontSize: 10, fontWeight: 500, textTransform: "uppercase", letterSpacing: 0.5, color: T.subtleFg },
});

export default function CompactStat({ value, label, tone = "default" }) {
  const s = useStyles();
  return (
    <div className={s.tile}>
      <div className={s.value} style={tone === "warning" ? { color: T.warning } : undefined}>
        {value}
      </div>
      <div className={s.label}>{label}</div>
    </div>
  );
}
